import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import cookies from 'vue-cookies'

Vue.use(Router)

// 处理多次点击同一路由报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: resolve => { require(['@/page/login/Login'], resolve) },
      meta: {
        title: '用户登录',
        noLogin: true
      }
    },
    {
      path: '/',
      name: 'Layout',
      redirect: '/home',
      component: resolve => require(['@/components/Layout'], resolve),
      children: [
        {
          path: '/home',
          name: 'Home',
          component: resolve => require(['@/page/home/Home'], resolve),
          meta: {
            title: '首页',
            breadcrumb: '首页'
          }
        },
        {
          path: '/user/index',
          name: 'User',
          component: resolve => require(['@/page/user/User'], resolve),
          meta: {
            title: '员工管理'
          }
        },
        {
          path: '/user/add',
          name: 'UserAdd',
          component: resolve => require(['@/page/user/UserAdd'], resolve),
          meta: {
            title: '员工管理-添加',
            breadcrumb: '员工模块/员工管理/添加'
          }
        },
        {
          path: '/user/edit/:id',
          name: 'UserEdit',
          component: resolve => require(['@/page/user/UserEdit'], resolve),
          meta: {
            title: '员工管理-编辑',
            breadcrumb: '员工模块/员工管理/编辑'
          }
        },
        {
          path: '/role/index',
          name: 'Role',
          component: resolve => require(['@/page/system/Role'], resolve),
          meta: {
            title: '角色管理'
          }
        },
        {
          path: '/role/add',
          name: 'RoleAdd',
          component: resolve => require(['@/page/system/RoleAdd'], resolve),
          meta: {
            title: '角色管理-添加',
            breadcrumb: '系统设置/角色管理/添加'
          }
        },
        {
          path: '/role/edit/:id',
          name: 'RoleEdit',
          component: resolve => require(['@/page/system/RoleEdit'], resolve),
          meta: {
            title: '角色管理-编辑',
            breadcrumb: '系统设置/角色管理/编辑'
          }
        },
        {
          path: '/role/limits/:id',
          name: 'RoleLimits',
          component: resolve => require(['@/page/system/RoleLimits'], resolve),
          meta: {
            title: '角色管理-权限',
            breadcrumb: '系统设置/角色管理/权限管理'
          }
        },
        {
          path: '/menu/index',
          name: 'Menu',
          component: resolve => require(['@/page/system/Menu'], resolve),
          meta: {
            title: '菜单管理'
          }
        },
        {
          path: '/menu/add',
          name: 'MenuAdd',
          component: resolve => require(['@/page/system/MenuAdd'], resolve),
          meta: {
            title: '菜单管理-添加',
            breadcrumb: '系统设置/菜单管理/添加'
          }
        },
        {
          path: '/menu/edit/:id',
          name: 'MenuEdit',
          component: resolve => require(['@/page/system/MenuEdit'], resolve),
          meta: {
            title: '菜单管理-编辑',
            breadcrumb: '系统设置/菜单管理/编辑'
          }
        },
        {
          path: '/user/limits',
          name: 'Limits',
          component: resolve => require(['@/page/user/Limits'], resolve),
          meta: {
            title: '操作权限'
          }
        },
        {
          path: '/user/limits/add',
          name: 'LimitsAdd',
          component: resolve => require(['@/page/user/LimitsAdd'], resolve),
          meta: {
            title: '操作权限-新增',
            breadcrumb: '系统设置/操作权限/新增'
          }
        },
        {
          path: '/user/limits/edit/:id',
          name: 'LimitsEdit',
          component: resolve => require(['@/page/user/LimitsEdit'], resolve),
          meta: {
            title: '操作权限-编辑',
            breadcrumb: '系统设置/操作权限/编辑'
          }
        },
        {
          path: '/department/index',
          name: 'Department',
          component: resolve => require(['@/page/user/Department'], resolve),
          meta: {
            title: '部门管理'
          }
        },
        {
          path: '/department/add',
          name: 'DepartmentAdd',
          component: resolve => require(['@/page/user/DepartmentAdd'], resolve),
          meta: {
            title: '部门管理-新增',
            breadcrumb: '员工模块/部门管理/新增'
          }
        },
        {
          path: '/department/edit/:id',
          name: 'DepartmentEdit',
          component: resolve => require(['@/page/user/DepartmentEdit'], resolve),
          meta: {
            title: '部门管理-编辑',
            breadcrumb: '员工模块/部门管理/编辑'
          }
        },
        {
          path: '/position/index',
          name: 'Position',
          component: resolve => require(['@/page/user/Position'], resolve),
          meta: {
            title: '职位管理'
          }
        },
        {
          path: '/website/contactus',
          name: 'ContactUs',
          component: resolve => require(['@/page/website/Contactus'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/website/case',
          name: 'Case',
          component: resolve => require(['@/page/website/Case'], resolve),
          meta: {
            title: '案例设置'
          }
        },
        {
          path: '/website/case/add',
          name: 'CaseAdd',
          component: resolve => require(['@/page/website/CaseAdd'], resolve),
          meta: {
            title: '案例设置-新增',
            breadcrumb: '官网设置/案例设置/新增'
          }
        },
        {
          path: '/website/case/edit/:id',
          name: 'CaseEdit',
          component: resolve => require(['@/page/website/CaseEdit'], resolve),
          meta: {
            title: '案例设置-编辑',
            breadcrumb: '官网设置/案例设置/编辑'
          }
        },
        {
          path: '/customer/index',
          name: 'Customer',
          component: resolve => require(['@/page/customer/Customer'], resolve),
          meta: {
            title: '客户管理'
          }
        },
        {
          path: '/customer/index/add',
          name: 'CustomerAdd',
          component: resolve => require(['@/page/customer/CustomerAdd'], resolve),
          meta: {
            title: '客户管理-新增',
            breadcrumb: '客户模块/客户管理/新增'
          }
        },
        {
          path: '/customer/index/edit/:id',
          name: 'CustomerEdit',
          component: resolve => require(['@/page/customer/CustomerEdit'], resolve),
          meta: {
            title: '客户管理-编辑',
            breadcrumb: '客户模块/客户管理/编辑'
          }
        },
        {
          path: '/customer/contact',
          name: 'Contact',
          component: resolve => require(['@/page/customer/Contact'], resolve),
          meta: {
            title: '客户联系人'
          }
        },
        {
          path: '/customer/contact/add',
          name: 'ContactAdd',
          component: resolve => require(['@/page/customer/ContactAdd'], resolve),
          meta: {
            title: '客户联系人-新增',
            breadcrumb: '客户模块/客户联系人/新增'
          }
        },
        {
          path: '/customer/contact/edit/:id',
          name: 'ContactEdit',
          component: resolve => require(['@/page/customer/ContactEdit'], resolve),
          meta: {
            title: '客户联系人-编辑',
            breadcrumb: '客户模块/客户联系人/编辑'
          }
        },
        {
          path: '/project/index',
          name: 'Project',
          component: resolve => require(['@/page/project/Project'], resolve),
          meta: {
            title: '项目管理'
          }
        }
      ]
    },
    {
      path: '*',
      name: '404',
      component: resolve => { require(['@/page/404'], resolve) },
      meta: {
        title: '找不到页面',
        noLogin: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  let state = store.state.login
  console.log(state)
  if (state) {
    cookies.set('login', true, 3600)
    cookies.set('token', store.state.token, 3600)
  } else {
    state = cookies.get('login')
    if (state) {
      store.commit('login')
      store.commit('token', cookies.get('token'))
    }
  }
  if (!to.meta.noLogin && !state) {
    return router.push({
      path: '/login'
    })
  }
  if (to.name === 'Login' && state) {
    if (store.state.userInfo.menuListDetailsList[0].menuListDetailsList !== null) {
      return router.push({
        path: store.state.userInfo.menuListDetailsList[0].menuListDetailsList[0].menu_url
      })
    } else {
      return router.push({
        path: store.state.userInfo.menuListDetailsList[0].menu_url
      })
    }
  }
  next()
})

router.afterEach(to => {
  document.title = to.meta.title
  window.scrollTo(0, 0)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js